"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcAvatar = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AcNameStamp_1 = require("../button/AcNameStamp");
var AcAvatar = function (_a) {
    var name = _a.name, imageUrl = _a.imageUrl, _b = _a.size, size = _b === void 0 ? 36 : _b, inCharge = _a.inCharge, className = _a.className;
    var style = {
        verticalAlign: 'middle',
        width: size + "px",
        height: size + "px",
    };
    if (!imageUrl) {
        var nameCharacter = '未';
        if (name && (name === null || name === void 0 ? void 0 : name.length) > 0) {
            nameCharacter = name[0];
        }
        return (react_1.default.createElement(AcNameStamp_1.AcNameStamp, { className: clsx_1.default(className), nameCharacter: nameCharacter, inCharge: inCharge, size: size, readOnly: true }));
    }
    return react_1.default.createElement("img", { className: clsx_1.default('avatar', className), style: style, src: imageUrl, alt: "Avatar" });
};
exports.AcAvatar = AcAvatar;
exports.AcAvatar.displayName = 'AcAvatar';
//# sourceMappingURL=AcAvatar.js.map